<template>
  <case-related-request></case-related-request>
</template>

<script>
import CaseRelatedRequest from '../components/case-related-request/index';

export default {
  components: { CaseRelatedRequest },
};
</script>
